import { action, createAsyncAction } from 'typesafe-actions';
import * as types from './createCourse.actionTypes';
import { Course } from '@nimbly-technologies/nimbly-common';

export const createCourse = createAsyncAction(
	types.CREATE_LMS_COURSE_REQUEST,
	types.CREATE_LMS_COURSE_SUCCESS,
	types.CREATE_LMS_COURSE_FAILURE,
)<{ data: Partial<Course> }, undefined, { error: string }>();
